import axios from 'axios'

import { ConsentRecord } from './types'
import { getConsents } from './getConsents'
import { acceptConsent } from './acceptConsent'

interface UpdateConsentProps {
  email: string
  consentStatus: boolean
  apiKey: string
  purposeId: string
  baseUrl: string
}

export async function updateConsent({
  email,
  consentStatus,
  apiKey,
  purposeId,
  baseUrl,
}: UpdateConsentProps) {
  const { data: consentRecords } = await getConsents({ apiKey, baseUrl })

  const record = await (async () => {
    const rec = consentRecords.find(
      (rec: ConsentRecord) => rec.attributes.email === email,
    )

    if (rec) {
      return rec.attributes
    } else if (consentStatus) {
      const response = await acceptConsent({
        apiKey: apiKey,
        purposeId: purposeId,
        baseURL: baseUrl,
        data: {
          email: email,
        },
      })
      return response.data?.[0]?.attributes || null
    }
    return null
  })()

  if (record) {
    const res = await axios.put(
      `${baseUrl}/api/v1/consent_records/${record.record_id}`,
      {
        status: consentStatus ? 'accepted' : 'withdrawn',
      },
      {
        headers: {
          Authorization: apiKey,
        },
      },
    )
    return res.data
  }
}
